const isObject = (item) => {
    return item != null && typeof item === "object" && !Array.isArray(item);
};
export const deepMergeLayerConfig = (target, source) => {
    var _a;
    const result = Object.assign({}, target);
    for (const key in source) {
        if (isObject(source[key])) {
            result[key] = deepMergeLayerConfig(((_a = target[key]) !== null && _a !== void 0 ? _a : {}), source[key]);
        }
        else if (Array.isArray(source[key]) && Array.isArray(target[key])) {
            const targetArray = result[key];
            const sourceArray = source[key];
            const resultArray = result[key];
            if (targetArray.length === 0 || targetArray[0].id == null || sourceArray.length === 0 || sourceArray[0].id == null) {
                result[key] = [...targetArray, ...sourceArray];
            }
            else {
                for (const amendedModule of sourceArray) {
                    const existingIndex = targetArray.findIndex((existingModule) => {
                        return existingModule.id === amendedModule.id;
                    });
                    if (existingIndex !== -1) {
                        Object.assign(targetArray[existingIndex], amendedModule);
                    }
                    else {
                        resultArray.push(amendedModule);
                    }
                }
            }
        }
        else {
            result[key] = source[key];
        }
    }
    return result;
};
